import {
  AccessTime,
  CalendarMonth,
  Category,
  DashboardCustomize,
  Inventory2,
  Logout,
  ReceiptLong,
  RouteOutlined,
  Settings,
} from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useLocation, useNavigate } from "react-router-dom";
import { BUILD_VERSION } from "buildInfo";
import { setAdminData } from "store/slices/admin.slice";
import { toggleDrawer } from "store/slices/main.slice";

const navItems = [
  { url: "/admin/setting/time", title: "Time Setting", icon: AccessTime },
  { url: "/admin/setting/project", title: "Project Setting", icon: Settings },
  { url: "/admin/inventory", title: "Inventory", icon: Inventory2 },
  { url: "/admin/orders", title: "All Orders", icon: ReceiptLong },
  {
    url: "/admin/CompanyProfile",
    title: "Customization",
    icon: DashboardCustomize,
  },
  { url: "/admin/setting/date", title: "Rest Dates", icon: CalendarMonth },
  { url: "/admin/departments", title: "Departments", icon: Category },
  {
    url: "/admin/delivery-distance",
    title: "Delivery Distance",
    icon: RouteOutlined,
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isTablet = useMediaQuery("(min-width:768px)");
  const showDrawer = useAppSelector(({ admin }) => admin.showDrawer);
  const drawerWidth = 248;

  return (
    <>
      {!isTablet && showDrawer && (
        <div
          className="absolute inset-0 z-10 bg-black/40 backdrop-blur-[1px]"
          onClick={() => dispatch(toggleDrawer())}
        />
      )}

      <motion.div
        className="z-20 h-full w-[248px] min-w-[248px] overflow-hidden border-r border-gray-200 bg-white max-md:absolute max-md:shadow-2xl"
        initial={{ translateX: !isTablet ? -drawerWidth : 0 }}
        animate={{ translateX: showDrawer || isTablet ? 0 : -drawerWidth }}
        transition={{ duration: 0.35 }}
      >
        <div className="flex h-full flex-col">
          <div className="px-4 pb-3 pt-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
              Menu
            </p>
          </div>

          <nav className="flex-1 space-y-1 px-3">
            {navItems.map(({ title, url, icon: Icon }) => {
              const active = location.pathname === url;

              return (
                <button
                  key={title}
                  type="button"
                  className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-semibold transition ${
                    active
                      ? "bg-primary text-themeSelColor shadow-sm"
                      : "text-gray-700 hover:bg-gray-100 hover:text-gray-950"
                  }`}
                  onClick={() => {
                    navigate(url);
                    if (!isTablet) dispatch(toggleDrawer());
                  }}
                >
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-lg transition ${
                      active
                        ? "bg-white/15 text-themeSelColor"
                        : "bg-gray-100 text-gray-500 group-hover:bg-white group-hover:text-gray-900"
                    }`}
                  >
                    <Icon className="!text-[20px]" />
                  </span>
                  <span>{title}</span>
                </button>
              );
            })}
          </nav>

          <div className="border-t border-gray-100 p-3">
            <button
              type="button"
              className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-semibold text-red-600 transition hover:bg-red-50"
              onClick={() => dispatch(setAdminData(undefined))}
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-50 text-red-600">
                <Logout className="!text-[20px]" />
              </span>
              <span>Log Out</span>
            </button>
            <div className="mt-3 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 text-right">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400">
                Version
              </p>
              <p className="font-mono text-xs font-bold text-gray-700">
                {BUILD_VERSION}
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
